import { Component, OnInit } from '@angular/core';
import {ProductService} from '../../_services/product.service';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Product} from '../../_models/product';
import {IProductCategory} from '../../_models/iproduct-category';
import {ProductCategoryService} from '../../_services/product-category.service';
import {Location} from '@angular/common';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import {AlertService} from '../../_services/alert.service';
import {PaymentMethod} from '../../_models/PaymentMethod';

@Component({
    selector: 'app-product-form',
    templateUrl: './product-form.component.html',
    styleUrls: ['./product-form.component.css'],
    standalone: false
})
export class ProductFormComponent implements OnInit {

  productForm: UntypedFormGroup;
  submitted: boolean;
  product: Product;
  title: string;
  productCategories: IProductCategory[] = [];
  selectedFile = null;
  imageChangedEvent: any = '';
  imageCroppedEvent: ImageCroppedEvent;
  croppedImage: any = '';
  croppedImageBase64: any = ''; // preview only
  croppedBlob: Blob | null = null; // actual binary sent to backend
  cropped = false;
  loading = true;

  constructor(private productService: ProductService, private router: Router,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private pcService: ProductCategoryService, private location: Location) {
    const item = window.localStorage.getItem('product');
    this.product = item ? JSON.parse(item) : new PaymentMethod();
    this.title = item ? 'Edit Product' : 'Add Product';
  }

  ngOnInit() {
    this.pcService.get_category_list().subscribe(
      (categories) => {
        this.productCategories = categories;
        this.formInit();
        this.loading = false;
      },
      () => {},
      () => {}
    );
  }

  formInit() {
    this.productForm = this.fb.group({
      id: new UntypedFormControl(this.product.id != null ? this.product.id : ''),
      name: new UntypedFormControl(this.product.id != null ? this.product.name : '', Validators.required),
      productNameFr: new UntypedFormControl(this.product.id != null ? this.product.productNameFr : '', Validators.required),
      categoryId: new UntypedFormControl(
          (this.product.id != null && this.product.category.id !== null ) ? this.product.category.id : 0, Validators.required),
      picture: new UntypedFormControl(''),
      status: new UntypedFormControl(this.product.id != null ? this.product.status : true )
    });
  }

  loadCategories() {

  }

  get f() {
    return this.productForm.controls;
  }

  onSelectedPicture( event ) {
    this.imageChangedEvent = event;
    this.selectedFile = event.target.files[0];
  }

  imageLoaded( ) {
    this.alertService.hide();
  }

  loadImageFailed( ) {
    this.selectedFile = null;
    this.alertService.error('Only PNG, JPEG and JPG files are allowed');
  }

  onCancelImageChangedEvent() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.croppedImageBase64 = '';
    this.croppedBlob = null;
    this.cropped = false;
    this.selectedFile = null;
  }

  onCrop() {
    if (!this.croppedBlob) {
      this.alertService.error('Image is still processing — please wait a moment and try Crop again.');
      return;
    }
    this.cropped = true;
  }

  imageCropped(imageCroppedEvent: ImageCroppedEvent) {
    this.imageCroppedEvent = imageCroppedEvent;
    const anyEvent = imageCroppedEvent as any;

    if (anyEvent.blob) {
      // newer ngx-image-cropper versions: real Blob, use directly for upload
      this.croppedBlob = anyEvent.blob;
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImageBase64 = reader.result as string; // just for <img> preview
      };
      reader.readAsDataURL(anyEvent.blob);
    } else if (imageCroppedEvent.base64) {
      // older versions: base64 string, convert to Blob for upload
      this.croppedImageBase64 = imageCroppedEvent.base64;
      this.croppedBlob = this.dataURLtoBlob(imageCroppedEvent.base64);
    }
  }

  private dataURLtoBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(',');
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/png';
    const binary = atob(parts[1]);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
  }

  onSubmit(event) {
    if (this.productForm.invalid) {
      return;
    }

    if (this.selectedFile && !this.croppedBlob) {
      this.alertService.error('Image could not be processed. Please re-select and crop the image again.');
      return;
    }

    this.submitted = true;

    const payload = { ...this.productForm.value };
    if (this.croppedBlob) {
      payload.picture = this.croppedBlob; // real Blob goes to the service now
    }

    this.product.id ? this.update(payload) : this.create(payload);
  }

  create(payload: any) {
    this.productService.addProduct(payload).subscribe(
        () => {
          this.router.navigate(['/admin/products']);
        },
        (err) => {
          console.error('Create product failed:', err);
          this.alertService.error(err?.error?.message || 'Failed to create product');
          this.submitted = false;
        }
    );
  }

  update(payload: any) {
    this.productService.updateProduct(payload).subscribe(
        () => {
          this.router.navigate(['/admin/products']);
        },
        (err) => {
          console.error('Update product failed:', err);
          this.alertService.error(err?.error?.message || 'Failed to update product');
          this.submitted = false;
        }
    );
  }

  backToPrevious() {
    this.location.back();
  }

}